export const COMPLIANCE_LIGHT_STATUS = {
  GREEN: 'green',
  YELLOW: 'yellow',
  RED: 'red',
};

export function getComplianceLightStatus(light = {}) {
  const normalizedStatus = String(light?.status || '').trim().toLowerCase();

  if (normalizedStatus === COMPLIANCE_LIGHT_STATUS.GREEN
    || normalizedStatus === COMPLIANCE_LIGHT_STATUS.YELLOW
    || normalizedStatus === COMPLIANCE_LIGHT_STATUS.RED) {
    return normalizedStatus;
  }

  return light?.ok ? COMPLIANCE_LIGHT_STATUS.GREEN : COMPLIANCE_LIGHT_STATUS.RED;
}

export function getComplianceLightPalette(light = {}) {
  const status = getComplianceLightStatus(light);

  if (status === COMPLIANCE_LIGHT_STATUS.YELLOW) {
    return {
      bgColor: 'warning.main',
      borderColor: 'warning.dark',
      textColor: 'warning.contrastText',
    };
  }

  if (status === COMPLIANCE_LIGHT_STATUS.GREEN) {
    return {
      bgColor: 'success.main',
      borderColor: 'success.dark',
      textColor: 'common.white',
    };
  }

  return {
    bgColor: 'error.main',
    borderColor: 'error.dark',
    textColor: 'common.white',
  };
}

export function getComplianceLightPdfColor(light = {}) {
  const status = getComplianceLightStatus(light);

  if (status === COMPLIANCE_LIGHT_STATUS.YELLOW) {
    return '#f59e0b';
  }

  if (status === COMPLIANCE_LIGHT_STATUS.GREEN) {
    return '#4caf50';
  }

  return '#f44336';
}

export function getComplianceAttentionSummary(lights = []) {
  return (lights || []).reduce((summary, light) => {
    const status = getComplianceLightStatus(light);

    if (status === COMPLIANCE_LIGHT_STATUS.RED) {
      summary.redCount += 1;
      summary.openCount += 1;
      return summary;
    }

    if (status === COMPLIANCE_LIGHT_STATUS.YELLOW) {
      summary.yellowCount += 1;
      summary.openCount += 1;
    }

    return summary;
  }, {
    redCount: 0,
    yellowCount: 0,
    openCount: 0,
  });
}